<template>
  <div id="app">
    <img :src="require('@/assets/bored_fish.jpg')" width="300" />
    <transition name="fade" mode="out-in">
      <h3 @click="newquote(false)" :key="'quote' + quid">{{quotes[quid]}}</h3>
    </transition>
    <div class="block">
    <p>My name is Mark.</p>
    <p>I'm a Brummie, but I live in Bedfordshire.</p>
    <p>I'm not a Peaky Blinder.</p>
    <p>I make software &amp; websites, and tinker with all sorts of other stuff.</p>
    <p>I swear too much, but I'm nice most of the time.</p>
    <p>I won a webby award once, too.</p>
    <p>But we won't talk about that.</p>
    <p>I love my job, but I occasionally freelance.</p>
    <p><a href="https://www.linkedin.com/in/mark-grainger-52374666/">hire me.</a> or <a href="#" @click="hello">say hello</a></p>
    </div>
  </div>
</template>

<script>
const SPEED = 4000;
var tm;

export default {
  mounted: function() {
    this.newquote();
  },
  data: function() {
    return {
      quotes: [
        'who lives in a pineapple under the sea?',
        'je suis le bored fish',
        'has anyone seen my screwdriver?',
        'hello? is it me you\'re looking for?',
        'my name is inigo montoya. you killed my father. prepare to die.',
        'do fish sneeze?',
        'i am le tired',
        'have you been to coventry?'
      ],
      quid: 0
    }
  },
  methods: {
    hello: function(e) {
      e.preventDefault();
      window.location.href = atob('bWFpbHRvOmhlbGxvQGJvcmVkZmlzaC5jb20=');
    },
    newquote: function(timer = true) {
      if (tm) {
        clearTimeout(tm);
      }

      this.quid ++;
      if (this.quid >= this.quotes.length) {
        this.quid = 0;
      }

      if (timer) {
        tm = setTimeout(this.newquote, SPEED);
      }
    }
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: "HandTIMES";
  src: url("./assets/fonts/HandTIMES.ttf");
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}s

body {
    font-size:18px;
}

#app {
  font-family: HandTIMES;
  font-size: 1.2rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 1rem auto 0;
  text-align: center;
  min-width: 400px;
  padding: 0 1rem;

  .block {
    border-top:1px solid #dddddd;
    width: auto; 
    display: inline-block; 
    padding-top: 1rem;
  }
}

h3 {
  cursor: pointer;
  font-size: 2.5rem;
  font-weight: normal;
  margin: 0 0 0.5rem 0;
}

p {
  margin: 0 0 0.5rem 0;
}
</style>